import { render, staticRenderFns } from "./AppRegister.vue?vue&type=template&id=5b3dc156&scoped=true&"
import script from "./AppRegister.vue?vue&type=script&lang=js&"
export * from "./AppRegister.vue?vue&type=script&lang=js&"
import style0 from "./AppRegister.vue?vue&type=style&index=0&id=5b3dc156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3dc156",
  null
  
)

export default component.exports